define.alias("shared/components/shared/social/tiktok-details", "media/components/shared/social/tiktok-details");